import React from "react";
import { Link } from "react-router-dom";
import SponsorFooter from "./SponsorFooter";
import { useTranslation } from "../hooks/useTranslation";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <>
      <SponsorFooter />
      <footer className="bg-gradient-to-t from-black via-zinc-900 to-transparent text-white py-12 inset-x-0 bottom-0">
        <div className="container mx-auto flex flex-col items-center text-center md:text-left">
          <p>{t("footerPowered")}: </p>
          <div className="mb-4">
            <a href="https://isilive.ca">
              <img
                src="/iSiLIVE_Logo_ForDarkBackgrounds.png"
                alt="iSiLIVE Logo"
                className="h-auto w-32 sm:w-40 md:w-48 lg:w-56 xl:w-64 max-w-full object-contain"
                loading="lazy"
              />
            </a>
          </div>
          <div className="flex flex-wrap justify-center space-x-4 md:space-x-6">
            <Link
              to="https://pickleballcanada.org/tournaments/pickleball-canada-national-championships/"
              className="text-gray-400 hover:text-white"
            >
              {t("footerWebsite")}
            </Link>
            <Link to="/admin" className="text-gray-400 hover:text-white">
              Admin
            </Link>
            {/*           <Link
            to="/systemrequirements"
            className="text-gray-400 hover:text-white"
          >
            System Requirements
          </Link> */}
            {/*           <Link to="/terms" className="text-gray-400 hover:text-white">
            Terms and Conditions
          </Link> */}
            {/*           <Link to="/faq" className="text-gray-400 hover:text-white">
            F.A.Q.
          </Link> */}
          </div>
          <div className="flex space-x-6 pt-6 text-gray-600 text-center text-sm sm:text-xs">
            Copyright ©2026 ISiLIVE | All Rights Reserved.
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
